import { useState } from "react";
import { X, ZoomIn } from "lucide-react";

const Gallery = ({ images }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  const openLightbox = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'unset';
  };

  return (
    <>
      {/* Gallery Grid */}
      <div 
        className="grid grid-cols-2 md:grid-cols-3 gap-4"
        data-testid="gallery-grid"
      >
        {images.map((image, index) => (
          <div
            key={index}
            className="relative aspect-square rounded-2xl overflow-hidden group cursor-pointer shadow-lg"
            onClick={() => openLightbox(image)}
            data-testid={`gallery-item-${index}`}
          >
            <img
              src={image.src}
              alt={image.alt}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              loading="lazy"
            />
            {/* Overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <p className="text-white text-sm font-medium">{image.alt}</p>
              </div>
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <div className="glass-dark rounded-full p-4">
                  <ZoomIn className="text-white" size={24} />
                </div>
              </div>
            </div>
            {/* Metallic Shine on Hover */}
            <div className="absolute inset-0 bg-gradient-to-br from-white/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
          </div>
        ))}
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div 
          className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-4"
          onClick={closeLightbox}
          data-testid="lightbox-overlay"
        >
          <button
            className="absolute top-4 right-4 text-white hover:text-[#F7A81B] transition-colors z-10 glass-dark p-3 rounded-full"
            onClick={closeLightbox}
            data-testid="lightbox-close"
          >
            <X size={24} />
          </button>
          
          <div 
            className="relative max-w-4xl max-h-[85vh] w-full animate-fade-in-up"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedImage.src}
              alt={selectedImage.alt}
              className="w-full h-full object-contain rounded-2xl"
              data-testid="lightbox-image"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 to-transparent p-6 rounded-b-2xl">
              <p className="text-white text-lg font-heading">{selectedImage.alt}</p>
              {selectedImage.description && (
                <p className="text-slate-300 text-sm mt-1">{selectedImage.description}</p>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Gallery;
